import { api } from '@/api'
import Button from '@/components/Button'
import NewsCard from '@/components/Cards/NewsCard'
import Container from '@/components/Container'
import Section from '@/components/Section'
import Title from '@/components/Title'
import { News } from '@/interfaces/News'
import React, { useEffect, useState } from 'react'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { dataStates } from '@garpix/fetcher'
import { usePage } from '@/hooks'
import BlockSpinner from '@/components/Spinner/BlockSpinner'
import style from './styles/news.module.scss'

const NewsSection = (): React.ReactElement => {
  const [mainNews, setMainNews] = useState<News | undefined>(undefined)
  const page = usePage()
  const { config } = page.init_state.global

  useEffect(() => {
    api
      .getMainNews()
      .then((data) => {
        setMainNews(data)
      })
      .catch((error) => {
        console.error(error)
      })
  }, [])

  return (
    <Section>
      <Container>
        <Title type='h2' theme='h1' className={style.title}>
          Новости
        </Title>
        {mainNews !== undefined
          ? (
            <NewsCard
              key={mainNews.id}
              title={mainNews.name}
              text={mainNews.preview_text}
              date={mainNews.active_from}
              image={mainNews.preview_picture?.[0]}
              url={`${config.news_detail}?element_id=${mainNews.id}`}
              bigCard
            />
            )
          : undefined}
        <FetcherList
          isScrollTop={false}
          isHistoryPush={false}
          initFilter={{ page_size: 4 }}
          api={api.getNewsList}
        >
          {({
            results,
            showMore,
            status,
            isNext
          }: IFetcherListResults<News[]>) => {
            return (
              <>
                <div className={style.news}>
                  {results.map((el, i) => {
                    return (
                      <NewsCard
                        key={el.id}
                        title={el.name}
                        text={el.preview_text}
                        date={el.active_from}
                        image={el.preview_picture?.[0]}
                        url={`${config.news_detail}?element_id=${el.id}`}
                      />
                    )
                  })}
                </div>
                {status === dataStates.loading ? <BlockSpinner /> : undefined}
                {isNext
                  ? (
                    <Button disabled={status === dataStates.loading} onClick={showMore} size='large' wide outline>
                      Показать еще
                    </Button>
                    )
                  : undefined}
              </>
            )
          }}
        </FetcherList>
      </Container>
    </Section>
  )
}

export default NewsSection
